// Statuswechsel (Agent 7A, R-13): je Lead-Status betreten, verlassen, Bestand am Anfang und Ende, Veränderung. Zeile aufklappen zeigt,
// wer die Wechsel gemacht hat. Der Bestand rechnet aus dem heutigen Stand zurück; mit Nutzerfilter entfällt er.
import { Fragment, useState } from "react";
import { berichteApi } from "../api/berichte";
import { Laden } from "../components/Bausteine";
import { Icon } from "../components/Icon";
import { statusFarbe, wirksameStatusFarbe } from "../werkzeuge/statusFarben";
import { BerichtSeite } from "./BerichtSeite";
import { useGeladen } from "./daten";
import { ganzText, veraenderungText } from "./format";
import { useBerichtSteuerung } from "./steuerung";
import { useBerichtFilter } from "./zustand";

const KEIN_ZUSATZ = {};

export function Statuswechsel() {
  const filter = useBerichtFilter("diese_woche");
  const steuerung = useBerichtSteuerung({ art: "statuswechsel", filter, zusatz: KEIN_ZUSATZ, onAnwenden: () => undefined });
  const [offen, setOffen] = useState<Set<string>>(new Set());
  const { eingabe, eingabeSchluessel } = filter;
  const abfrage = useGeladen(() => berichteApi.statuswechsel({ ...eingabe, vergleich: undefined }), eingabeSchluessel, steuerung.geladen);
  const daten = abfrage.daten;
  const umschalten = (id: string) => setOffen((s) => { const n = new Set(s); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  return (
    <BerichtSeite
      art="statuswechsel"
      filter={filter}
      steuerung={steuerung}
      ohneVergleich
      fehler={abfrage.fehler}
      onNochmal={abfrage.neuLaden}
      csv={[{ titel: "Tabelle als CSV laden", art: "statuswechsel", parameter: { ...eingabe, vergleich: undefined } }]}
    >
      {!daten ? (
        <Laden />
      ) : (
        <div className="tabelle-rahmen bericht-tabelle" aria-busy={abfrage.laedt}>
          <p className="bericht-hinweis">Leads: Wie sich die Lead-Status im Zeitraum verändert haben.</p>
          <table className="tabelle">
            <thead>
              <tr>
                <th className="bericht-tabelle__nutzer">Status</th>
                <th className="bericht-tabelle__zahl">Betreten</th>
                <th className="bericht-tabelle__zahl">Verlassen</th>
                <th className="bericht-tabelle__zahl">Anfang → Ende</th>
                <th className="bericht-tabelle__zahl">Veränderung</th>
              </tr>
            </thead>
            <tbody>
              {daten.data.map((z) => {
                const auf = offen.has(z.status_id);
                const kannAuf = (z.nach_nutzer?.length ?? 0) > 0;
                const farbe = statusFarbe(wirksameStatusFarbe(z.label, z.farbe));
                return (
                  <Fragment key={z.status_id}>
                    <tr>
                      <td className="bericht-tabelle__nutzer">
                        <button type="button" className="bericht-aufklapp" disabled={!kannAuf} aria-expanded={auf} onClick={() => umschalten(z.status_id)} aria-label={`Wer hat „${z.label}“ geändert`}>
                          <Icon name={auf ? "chevron-unten" : "chevron-rechts"} groesse={12} />
                        </button>
                        <span className="bericht-statuspunkt" style={{ background: `var(--status-${farbe}-fg)` }} aria-hidden="true" />
                        {z.label}
                      </td>
                      <td className="bericht-tabelle__zahl">{ganzText(z.betreten)}</td>
                      <td className="bericht-tabelle__zahl">{ganzText(z.verlassen)}</td>
                      <td className="bericht-tabelle__zahl">{z.start === null ? "–" : `${ganzText(z.start)} → ${ganzText(z.ende)}`}</td>
                      <td className={`bericht-tabelle__zahl bericht-netto bericht-netto--${z.netto > 0 ? "plus" : z.netto < 0 ? "minus" : "null"}`}>
                        {z.netto > 0 ? "+" : ""}
                        {ganzText(z.netto)}
                        {z.netto_prozent !== null && z.netto_prozent !== undefined ? <span className="leise"> ({veraenderungText(z.netto_prozent)})</span> : null}
                      </td>
                    </tr>
                    {auf
                      ? z.nach_nutzer?.map((n) => (
                          <tr key={n.nutzer_id} className="bericht-unterzeile">
                            <td className="bericht-tabelle__nutzer bericht-unterzeile__name">{n.titel}</td>
                            <td className="bericht-tabelle__zahl">{ganzText(n.betreten)}</td>
                            <td className="bericht-tabelle__zahl">{ganzText(n.verlassen)}</td>
                            <td colSpan={2} />
                          </tr>
                        ))
                      : null}
                  </Fragment>
                );
              })}
            </tbody>
            {daten.summe ? (
              <tfoot>
                <tr>
                  <td className="bericht-tabelle__nutzer"><strong>Gesamt</strong></td>
                  <td className="bericht-tabelle__zahl"><strong>{ganzText(daten.summe.betreten)}</strong></td>
                  <td className="bericht-tabelle__zahl"><strong>{ganzText(daten.summe.verlassen)}</strong></td>
                  <td className="bericht-tabelle__zahl"><strong>{daten.bestand_bekannt === false ? "–" : `${ganzText(daten.summe.start)} → ${ganzText(daten.summe.ende)}`}</strong></td>
                  <td />
                </tr>
              </tfoot>
            ) : null}
          </table>
          {daten.bestand_bekannt === false ? <p className="leise bericht-hinweis">Mit Nutzerfilter zeigt der Bericht nur die Wechsel dieser Personen; den Bestand kann man keinem Nutzer zuordnen.</p> : null}
        </div>
      )}
    </BerichtSeite>
  );
}
